<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-seasons"
        title = "Lista sezonów"
        :numeral_text = "['sezon', 'sezony', 'sezonów']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>